/**
 * @swoft/platform-contracts - DDD-Compliant Dependency Injection Contracts
 *
 * Defines clean architecture boundaries and dependency injection contracts
 * following Domain-Driven Design and Hexagonal Architecture principles.
 *
 * This package has ZERO dependencies to avoid circular dependencies.
 * All bounded contexts depend on contracts, not on each other.
 */

// Infrastructure Layer Contracts
export * from './infrastructure';

// Domain Layer Contracts
export * from './domain';

// Application Layer Contracts
export * from './application';

// Cross-Cutting Concerns
export * from './shared';

// Contract Registry (Single source of truth)
export * from './ContractRegistry';
